const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLamp3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 183.24 700",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "97157b73-9447-4d6e-8c2c-ee45e88286e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4,5.3C10.5,11.9-3,152.4.6,157.6s172,4.3,179.3,0S166,4.6,157.2,2C148.6-.6,30.7-1.5,20.4,5.3",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path5076",
    d: "M12.3,692.8l1.2-7.7,1.1-8,2.1-16,4.2-32,8.2-64L45.3,437,77.4,180.7c.7-5.2,4.8-8.8,9.3-8.1s7.6,5.6,6.9,10.8v.2L56.5,439,37.8,566.7l-9.5,63.8-4.8,31.9-2.5,16-1.3,8-1.4,8.2a3.11,3.11,0,0,1-3.7,2.8,3.55,3.55,0,0,1-2.4-4.2l.1-.4",
    style: {
      fill: "#cc9266"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5078",
    d: "M176.8,694.4,92.6,184.7c-.8-4.6,1.8-9,5.7-9.9s7.7,2.1,8.5,6.7v.1L183.2,693a3.84,3.84,0,0,1-2.61,4.4c-1.79.4-3.39-1-3.79-3",
    style: {
      fill: "#cc9266"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5080",
    d: "M90.7,696.7,88.1,400.2,86.8,251.9l-.6-74.1-1.31-74.1c-.1-5.1,3.4-9.3,7.9-9.4s8.1,3.9,8.2,9v74.4l-.6,74.1-1.3,148.3-2.6,296.6a2.92,2.92,0,1,1-5.79,0",
    style: {
      fill: "#cc9266"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5082",
    d: "M79.5,170c-3.7,3.4-11.3,45.5-9.11,48.1s44.2,5.2,45.61-1.1c1.8-8.2-7.61-45.8-9.8-46.7-2.3-.7-26.7-.3-26.7-.3",
    style: {
      fill: "#dab68c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5084",
    d: "M86.6,220.7a87.59,87.59,0,0,1-13.9-1.6h0a120.27,120.27,0,0,0,13.9,1.6h0",
    style: {
      fill: "#c68a5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5086",
    d: "M96.3,220.9c-3.2,0-6.5-.1-9.7-.3h0c3.1.2,6.4.3,9.7.3h0",
    style: {
      fill: "#c68a5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5088",
    d: "M96.3,220.9c-3.2,0-6.5-.1-9.7-.3A87.59,87.59,0,0,1,72.7,219a4.67,4.67,0,0,1-2.3-.9h0l-.1-.1c12.9-2.7,29.8-6.8,32.1-10.3,3.4-4.9,4.9-26.6,3.4-37.3l.3.1c2.2.9,11.7,38.4,9.8,46.7-.6,2.7-9.7,3.7-19.6,3.7",
    style: {
      fill: "#d4ac7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5090",
    d: "M78.5,204.9a29.92,29.92,0,0,1-.11-6.6,48.1,48.1,0,0,1,.81-6.5c.39-2.1.89-4.3,1.5-6.4a23.31,23.31,0,0,1,2.69-6.1c-.1,2.2-.1,4.4-.3,6.6s-.5,4.3-.89,6.4-.81,4.3-1.4,6.4a42.88,42.88,0,0,1-2.3,6.2",
    style: {
      fill: "#e1c5a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5092",
    d: "M20.4,5.3C10.5,11.9-3,152.4.6,157.6s172,4.3,179.3,0S166,4.6,157.2,2C148.6-.6,30.7-1.5,20.4,5.3",
    style: {
      fill: "#5e8c89"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5094"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#97157b73-9447-4d6e-8c2c-ee45e88286e4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5102",
    d: "M154.4,73.2q-5.25-34.35-12.2-68.3c1-.2,2.1-.3,3.1-.5,4,19.4,7.6,39,10.7,58.6-.5,3.4-1,6.8-1.6,10.2M144.5.9c-1-.1-2.11-.1-3.2-.1h0c1.2,0,2.2,0,3.2.1h0",
    style: {
      fill: "#89aaa9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5104",
    d: "M137.5,117.2Q133.3,62,126.3,7.2c1-.1,2.1-.3,3.1-.4q6.9,53.1,10.9,106.7a35.83,35.83,0,0,1-2.8,3.7M128.5.4c-1,0-2.11,0-3.11-.1h0c1.11,0,2.11,0,3.11.1h0",
    style: {
      fill: "#89aaa9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5106",
    d: "M112.4,160.9h0m-.2-28.9q-.9-61.2-4.9-122.2c1-.1,2.1-.3,3.1-.4q4,60.6,5,121.4c-1.1.4-2.1.8-3.2,1.2M109.7.1h0",
    style: {
      fill: "#89aaa9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5108",
    d: "M17.7,159.9c-1.1-.1-2.1-.1-3.1-.2h0c1,0,2.1.1,3.1.2h0m-2.8-4.2A1181.31,1181.31,0,0,1,30.2,25.4c1.1-.4,2.2-.8,3.4-1.2a1170.35,1170.35,0,0,0-15.5,131,26.94,26.94,0,0,0-3.2.5",
    style: {
      fill: "#89aaa9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5110",
    d: "M40,160.7c-1.11,0-2.11-.1-3.11-.1h0c1,0,2,.1,3.11.1h0m-2.7-9.2Q40.75,85.05,50.2,19.4c1.1-.3,2.1-.5,3.19-.7C47,62.4,42.7,106.6,40.39,150.9l-3.09.6",
    style: {
      fill: "#89aaa9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5112",
    d: "M64.8,161.1H61.7c1-.1,2,0,3.1,0h0m-3.2-14.8A1190.6,1190.6,0,0,1,69.1,15.5l3.2-.6a1161.6,1161.6,0,0,0-7.6,130.6,17.68,17.68,0,0,1-3.1.8",
    style: {
      fill: "#89aaa9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5114",
    d: "M84.2,161.1h0m.7-20.5c.7-26.9,1.1-53.9,1.1-80.8,0-15.6-.1-31.3-.4-46.9,1-.2,2.1-.3,3.1-.5.3,15.8.4,31.6.4,47.4,0,26.7-.4,53.3-1.1,80a28.06,28.06,0,0,0-3.1.8M85.4.2h0",
    style: {
      fill: "#89aaa9"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path5116",
    d: "M20.2,5.5h0m0,0h0m.1,0h0m0-.1h0m0,0h0m.1,0h0m0,0h0m0-.1h0m0,0C24.7,2.4,48,.9,74.3.4,48.1,1,24.8,2.5,20.4,5.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5118",
    d: "M11.3,38.9h0c2.9-17.7,6-30.9,8.9-33.4h0C24.5,2.6,47.8,1.1,74.09.6,77.7.5,81.39.5,85.2.4c.1,4.2.19,8.5.19,12.7-4.5.7-8.89,1.4-13.3,2.1.61-4.9,1.2-9.8,1.8-14.6-1,0-2.1.1-3.1.1-.7,5-1.3,10.1-1.8,15.1-5.4,1-10.7,2-15.7,3.1L56,1.2c-1.1.1-2.1.1-3.2.1-1,6.1-1.9,12.2-2.8,18.3-6,1.4-11.6,3-16.7,4.7,1.3-7.4,2.7-14.7,4.1-22l-3.19.3c-1.5,7.6-2.9,15.3-4.2,22.9-9.5,3.5-16.3,8-18.7,13.4M88.7,12.4c-.1-4.1-.1-8.2-.2-12.3C93,0,97.6,0,102,0h4.6c.2,3.2.5,6.5.7,9.7-6.1.9-12.4,1.8-18.6,2.7m21.7-3L109.8.1c5.5,0,10.8.1,15.7.2q.45,3.45.89,6.9c-5.19.7-10.49,1.5-16,2.2m19-2.6c-.3-2.2-.5-4.3-.8-6.5,4.7.1,9,.2,12.8.4.3,1.4.6,2.7.9,4.1-4.1.7-8.4,1.4-12.9,2m15.9-2.4c-.2-1.2-.5-2.3-.7-3.5A96.94,96.94,0,0,1,157.2,2c-3.4.8-7.4,1.6-11.9,2.4",
    style: {
      fill: "#6e9895"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5120",
    d: "M142.2,4.9c-.3-1.4-.6-2.8-.9-4.1,1.1,0,2.2.1,3.2.1.2,1.2.5,2.3.7,3.5-.9.1-2,.3-3,.5",
    style: {
      fill: "#95b3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5122",
    d: "M126.3,7.2,125.4.3c1.1,0,2.1.1,3.1.1.3,2.1.6,4.3.8,6.5-.9,0-2,.2-3,.3",
    style: {
      fill: "#95b3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5124",
    d: "M107.3,9.8c-.2-3.2-.5-6.5-.7-9.7h3.1l.6,9.3c-1,.1-2,.3-3,.4",
    style: {
      fill: "#95b3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5126",
    d: "M30.2,25.3C31.5,17.6,33,10,34.4,2.4l3.2-.3c-1.4,7.3-2.8,14.6-4.1,22l-3.3,1.2",
    style: {
      fill: "#95b3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5128",
    d: "M50.2,19.4C51.1,13.3,52,7.2,53,1.1c1,0,2.1-.1,3.2-.1L53.5,18.7c-1.1.2-2.2.5-3.3.7",
    style: {
      fill: "#95b3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5130",
    d: "M69.1,15.6c.6-5,1.2-10.1,1.8-15.1,1,0,2.1-.1,3.1-.1-.6,4.9-1.2,9.8-1.8,14.6-1,.2-2,.4-3.1.6",
    style: {
      fill: "#95b3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5132",
    d: "M85.6,12.9c-.1-4.2-.1-8.5-.2-12.7h3.1c.1,4.1.1,8.2.2,12.3a29.09,29.09,0,0,0-3.1.4",
    style: {
      fill: "#95b3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5134",
    d: "M121.7,160.8c6.5-.1,12.8-.2,18.6-.4h0c1,0,2.1-.1,3.1-.1h0c8.2-.2,15.5-.5,21.4-.9h0c1.1-.1,2.1-.1,3.1-.2h0c1.2-.1,2.4-.2,3.4-.3-10.4.9-28.7,1.6-49.6,1.9m49.8-1.9h0",
    style: {
      fill: "#dfe8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5136",
    d: "M83.1,161.1c-6.2,0-12.4,0-18.3-.1-.1-4.4-.1-8.8-.1-13.3v-2.2c6.8-1.6,13.6-3.3,20.19-5-.19,6.8-.39,13.7-.6,20.5a4.75,4.75,0,0,1-1.19.1m4.2,0c.2-7.1.5-14.3.7-21.4,8.7-2.4,17-5,24.3-7.7.1,9.6.2,19.3.2,28.9-8.3.2-16.7.2-25.2.2M61.7,161,40,160.7c.1-3.3.3-6.5.5-9.8,6.8-1.4,13.9-2.9,21.2-4.5v1.5c-.1,4.3-.1,8.7,0,13.1m53.8-.1c0-10-.11-20-.2-30.1,6.4-2.6,11.9-5.2,15.9-8a33.52,33.52,0,0,0,6.3-5.7c1.1,14.4,2,28.8,2.8,43.2-5.9.2-12.1.3-18.6.4-2.1.2-4.1.2-6.2.2m-78.6-.3c-7.2-.2-13.7-.4-19.1-.7.1-1.6.2-3.1.3-4.7,5.7-1,12.2-2.2,19.3-3.6-.3,2.9-.4,6-.5,9m106.5-.3c-.9-15.6-1.9-31.2-3.1-46.8,7-10.1,11.4-24.8,14.1-40.3q6.6,42.9,10.3,86.2c-5.8.4-13.1.7-21.3.9m-128.8-.6c-6.9-.5-11.7-1-13.3-1.7,3.2-.5,7.9-1.3,13.6-2.3-.1,1.3-.2,2.6-.3,4m153.3-.5Q163.7,110.75,156,63c3.3-25.7,2.5-51.4,1.4-61,8.8,2.6,30,151.3,22.7,155.6-.9.5-3.9.9-8.5,1.3h-.2c-1.2.2-2.3.2-3.5.3",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5138",
    d: "M164.8,159.4c-2.5-28.9-6-57.6-10.3-86.2q.9-5.1,1.5-10.2,7.65,47.85,11.89,96.2a29.9,29.9,0,0,1-3.09.2",
    style: {
      fill: "#789b99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5140",
    d: "M140.3,160.4c-.8-14.4-1.7-28.8-2.8-43.2a37.32,37.32,0,0,0,2.8-3.7c1.2,15.6,2.2,31.2,3.1,46.8-1,0-2.1.1-3.1.1",
    style: {
      fill: "#789b99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5142",
    d: "M112.4,160.9c0-9.6-.1-19.3-.2-28.9,1-.4,2.1-.8,3.1-1.2.1,10,.2,20,.2,30.1h-3.1",
    style: {
      fill: "#789b99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5144",
    d: "M17.7,159.9c-1.1-.1-2.1-.1-3.1-.2.1-1.3.1-2.7.2-4l3.1-.6c0,1.6-.1,3.2-.2,4.8",
    style: {
      fill: "#789b99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5146",
    d: "M40,160.7c-1.11,0-2.11-.1-3.11-.1.11-3,.31-6.1.4-9.1l3.1-.6c-.09,3.2-.29,6.5-.39,9.8",
    style: {
      fill: "#789b99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5148",
    d: "M64.8,161.1H61.7c-.11-4.4-.11-8.8-.11-13.2v-1.5c1-.2,2.11-.5,3.11-.7v2.2c0,4.3,0,8.7.1,13.2",
    style: {
      fill: "#789b99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5150",
    d: "M84.2,161.1c.2-6.8.4-13.7.6-20.5l3.1-.9c-.2,7.1-.4,14.2-.7,21.4h-3",
    style: {
      fill: "#789b99"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLamp3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lamp3.0dc6b8829820f1399108fbb6edc7e81a.svg";